import type { PropsWithChildren, ReactNode } from 'react'
import React from 'react'
import Menu from '../Menu/Menu'

interface GroupProps {
  /**
   * The label for the group of options
   * @default null
   */
  label?: ReactNode
}

function Group({
  children,
  label = null,
}: PropsWithChildren<GroupProps>): JSX.Element {
  return <Menu.Group label={label}>{children}</Menu.Group>
}

Group.uiName = 'Select.Group'

export default Group
